module.exports = __webpack_public_path__ + "static/media/Oracle PLSQL.e23a906f.png";